import { initialHomePageState, HomePageState } from 'mk2/apps/home/containers/Home/Home.reducers';
import { AppState } from 'mk2/reducers';

export const getHomeState = (state: AppState): HomePageState =>
    state.containers.home.home || initialHomePageState;
